/**
 * Revision History
 * Data Model for OI Load Plan List
 * 
 * 02/25/2022       hykim       Create
 */
import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class OiLoadListItem extends SearchModelBase {
    id: number = 0;
    loadNo: string = '';
    sName: string = '';
    amount: number|null = null;
    fromAmount: number|null = null;
    toAmount: number|null = null;
    truckingETD: string | null = null;
    fromTruckingETD: string | null = null;
    toTruckingETD: string | null = null;
    postDate: string | null = null;
    fromPostDate: string | null = null;
    toPostDate: string | null = null;
    createdAt: string | null = null;
    truckingCoId: number = 0;
    warehouseId: number = 0;
    warehouseName: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    u2Id: string = '';
    u1Id: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'postDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
        XCol.Create({ col: 2, text: 'Load #', width: 100, dataIndex: 'loadNo', defaultColumnFocus : true}),
        XCol.Create({ col: 3, text: 'Trucking Vendor', width: 120, dataIndex: 'sName'}),
        XCol.Create({ col: 4, text: 'Warehouse', width: 120, dataIndex: 'warehouseName'}),
        XCol.Create({ col: 5, text: 'Amount', width: 100, dataIndex: 'amount', type: XCol.XCellType.Double, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 6, text: 'Trucking ETD', width: 75, dataIndex: 'truckingETD', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
        XCol.Create({ col: 7, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
        XCol.Create({ col: 8, text: 'Create by', width: 80, dataIndex: 'u1Id'}),
        XCol.Create({ col: 9, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy'}),
        XCol.Create({ col: 10, text: 'Update by', width: 80, dataIndex: 'u2Id'}),
        ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: OiLoadListItem.prototype.createdAt, orderByAscending: false };

    public static formatData(data: OiLoadListItem[]) {
        return data.map((d: OiLoadListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        amount: {from: 'fromAmount', to: 'toAmount'},
        truckingETD: {from: 'fromTruckingETD', to: 'toTruckingETD'},
        postDate: {from: 'fromPostDate', to: 'toPostDate'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
    };

}
